import React from 'react';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import i18n from 'i18n';
import { toLocalString } from 'util/filters';
import imgImagePC1x from 'assets/images/PC/@1x/img_image.png';
import imgImagePC2x from 'assets/images/PC/@2x/img_image@2x.jpg';
import imgImageSP2x from 'assets/images/SP/@2x/img_image@2x.jpg';
import imgImageSP3x from 'assets/images/SP/@3x/img_image@3x.jpg';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import CustomMedia from 'util/custom-media-query';

const ContentHeader = ({ className, price }) => (
  <div className={className}>
    <Image
      pc1x={imgImagePC1x}
      pc2x={imgImagePC2x}
      sp2x={imgImageSP2x}
      sp3x={imgImageSP3x}
      alt="img_image"
    />
    <div className="content">
      <h2>{i18n.t('orderAggregators:purchase:itemName')}</h2>
      <p className="price">
        {toLocalString(price)}
        <span className="suffix">{i18n.t('common:yen')}</span>
      </p>
      <p className="description">
        {i18n.t('orderAggregators:purchase:headerDescription')}
      </p>
    </div>
  </div>
);

const commonStyle = css`
  color: ${Colors.black1};

  h2 {
    ${FontStyles.text5};
    line-height: 1 !important;
  }

  .price {
    ${FontStyles.text1};
  }

  .description {
    ${FontStyles.text8};

    margin: 0;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  display: flex;
  margin-bottom: 56px;

  img {
    margin-right: 32px;
  }

  h2 {
    margin: 0 0 16px 0;
  }

  .price {
    margin: 0 0 24px 0;

    .suffix {
      ${FontStyles.text5};
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin-bottom: 24px;

  img {
    max-width: 100%;
  }

  h2 {
    margin: 24px 0 8px;
  }

  .price {
    margin: 0 0 16px 0;

    .suffix {
      ${FontStyles.text3};
    }
  }
`;

export default applyStyles(ContentHeader)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Purchase/components/ContentHeader.js